import { Button2 } from "@/ui2/atoms/Button";

import { useCosignatureModal } from "../CosignatureModalProvider";
import { useCosignatureSelectionState } from "../CosignatureSelectionProvider";

export function BatchControls() {
  const { openBatchModal } = useCosignatureModal();
  const { selectedItems } = useCosignatureSelectionState();

  if (selectedItems.length === 0) return null;

  return (
    <div className="tw:flex tw:gap-4 tw:md:ml-auto">
      <Button2
        onPress={() => openBatchModal({ action: "reject", items: selectedItems })}
        variant="destructive-primary"
      >
        Reject
      </Button2>

      <Button2
        onPress={() => openBatchModal({ action: "cosign", items: selectedItems })}
        variant="primary"
      >
        Approve
      </Button2>
    </div>
  );
}
